<div class="file-status-overlay">
  <div class="file-status-modal">
    <h4>File(s) upload is in progress. Closing the web browser in the meantime will cause the upload(s) to fail. </h4>
    <div class="file-status-table-header row m-0">
      <div class="col-6"><b>File Name</b></div>
      <div class="col-2"><b>File Size</b></div>
      <div class="col-2"><b>Status</b></div>
    </div>

   <div class="file-status-table-body">
        <div class="row m-0 file-row" *ngFor="let file of FilesToUpload">
            <div class="col-6 text-break">{{ file.fileName }}</div>
            <div class="col-2">{{ file.sizeReadable }}</div>
            <div class="col-2">{{ getStatusText(file) }}</div>
        </div>
    </div>
    <div *ngIf="hasErrorInUpload">
      <button type="button" class="btn-enter ml-5" (click)="removeAndGoBackToUploadPage()"> Remove/Replace All Errored Uploads </button>
    </div>
  </div>
</div>